const PROD_API_BASE_URL = 'https://atmwater-backend.zeabur.app';
const DEV_API_BASE_URL = 'https://atmwater-backend-dev.zeabur.app';
const INDONESIA_STAGING_API_BASE_URL = 'https://atmwater-backend-id-staging.zeabur.app';
const INDONESIA_PROD_V2_API_BASE_URL = 'https://atmwater-backend-id-prod-v2.zeabur.app';

const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

export const resolveRuntimeApiBaseUrl = ({ hostname, apiUrl, nodeEnv } = {}) => {
  const resolvedHostname = String(
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')
  ).toLowerCase();
  if (resolvedHostname === 'atmwater-admin-id-prod-v2.zeabur.app') {
    return INDONESIA_PROD_V2_API_BASE_URL;
  }
  if (resolvedHostname === 'atmwater-admin-id-staging.zeabur.app') {
    return INDONESIA_STAGING_API_BASE_URL;
  }
  if (resolvedHostname === 'atmwater-admin-dev.zeabur.app') {
    return DEV_API_BASE_URL;
  }

  const resolvedApiUrl = apiUrl ?? process.env.REACT_APP_API_URL;
  if (resolvedApiUrl) {
    return trimTrailingSlash(resolvedApiUrl);
  }

  if ((nodeEnv ?? process.env.NODE_ENV) === 'development') {
    return DEV_API_BASE_URL;
  }

  return PROD_API_BASE_URL;
};

export const API_BASE_URL = resolveRuntimeApiBaseUrl();

export default API_BASE_URL;
